import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer, useRef } from 'react';
import { Button, Modal, Select, Textarea } from '@skbkontur/react-ui';
import { ValidationContainer, ValidationWrapper } from '@skbkontur/react-ui-validations';
import { checkNotEmpty, checkYearInRange, getTextValidation } from '../../helpers/validators';
import { FieldWrapper } from '../FieldWrapper';
import { TrimmedInput } from '../TrimmedInput';
import classes from './EducationModal.module.css';
const getDefaultState = (defaultEducation) => {
    return {
        level: defaultEducation?.level || null,
        organizationName: defaultEducation?.organizationName || '',
        qualification: defaultEducation?.qualification || '',
        speciality: defaultEducation?.speciality || '',
        series: defaultEducation?.series || '',
        endingYear: defaultEducation?.endingYear?.toString() || '',
    };
};
const getEducationDef = (state) => {
    if (state.level === null) {
        return null;
    }
    return {
        level: state.level,
        organizationName: state.organizationName.trim() || undefined,
        qualification: state.qualification.trim() || undefined,
        speciality: state.speciality.trim() || undefined,
        series: state.series.trim() || undefined,
        endingYear: Number(state.endingYear.trim()) || undefined,
    };
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'changeLevel': {
            return {
                ...state,
                level: action.payload,
            };
        }
        case 'changeOrganizationName': {
            return {
                ...state,
                organizationName: action.payload,
            };
        }
        case 'changeQualification': {
            return {
                ...state,
                qualification: action.payload,
            };
        }
        case 'changeSpeciality': {
            return {
                ...state,
                speciality: action.payload,
            };
        }
        case 'changeSeries': {
            return {
                ...state,
                series: action.payload,
            };
        }
        case 'changeEndingYear': {
            return {
                ...state,
                endingYear: action.payload,
            };
        }
    }
};
export const EducationModal = ({ value, educationLevels, onClose, onSubmit, onCancel, onValidationError, }) => {
    const [state, dispatch] = useReducer(reducer, getDefaultState(value));
    const refValidationContainer = useRef(null);
    const handleSubmit = async () => {
        const isValid = await refValidationContainer.current?.validate();
        if (!isValid) {
            onValidationError();
            return;
        }
        onSubmit(getEducationDef(state));
    };
    const allValuesEmpty = Object.values(state)
        .map((el) => (el || '').trim())
        .join('').length === 0;
    return (_jsxs(Modal, { onClose: onClose, ignoreBackgroundClick: true, children: [_jsx(Modal.Header, { children: "\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435" }), _jsx(Modal.Body, { children: _jsx(ValidationContainer, { ref: refValidationContainer, children: _jsxs("div", { className: classes.fields, children: [_jsx(FieldWrapper, { label: "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F", children: _jsx(ValidationWrapper, { validationInfo: allValuesEmpty ? null : checkNotEmpty({ value: state.level }), children: _jsx(Select, { width: 346, value: state.level, onValueChange: (payload) => { dispatch({ type: 'changeLevel', payload }); }, items: [
                                            ['', 'Не заполнено'],
                                            ...educationLevels.map(({ code, name }) => [code, name]),
                                        ] }) }) }), _jsx(FieldWrapper, { label: "\u0421\u0435\u0440\u0438\u044F \u0438 \u043D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430", children: _jsx(TrimmedInput, { width: 174, value: state.series, onValueChange: (payload) => { dispatch({ type: 'changeSeries', payload }); }, validationInfo: getTextValidation(state.series) }) }), _jsx(FieldWrapper, { label: "\u041A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F", children: _jsx(TrimmedInput, { width: 174, value: state.qualification, onValueChange: (payload) => { dispatch({ type: 'changeQualification', payload }); }, validationInfo: getTextValidation(state.qualification) }) }), _jsx(FieldWrapper, { label: "\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C/\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435", children: _jsx(TrimmedInput, { width: 346, value: state.speciality, onValueChange: (payload) => { dispatch({ type: 'changeSpeciality', payload }); }, validationInfo: getTextValidation(state.speciality) }) }), _jsx(FieldWrapper, { label: "\u041D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438", children: _jsx(ValidationWrapper, { validationInfo: getTextValidation(state.organizationName), children: _jsx(Textarea, { width: 346, value: state.organizationName, onValueChange: (payload) => { dispatch({ type: 'changeOrganizationName', payload }); } }) }) }), _jsx(FieldWrapper, { label: "\u0413\u043E\u0434 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F", children: _jsx(TrimmedInput, { width: 54, value: state.endingYear, onValueChange: (payload) => { dispatch({ type: 'changeEndingYear', payload }); }, mask: '9999', maskChar: null, validationInfo: getTextValidation(state.endingYear) || checkYearInRange({ value: state.endingYear }) }) })] }) }) }), _jsxs(Modal.Footer, { panel: true, gap: 8, children: [_jsx(Button, { onClick: handleSubmit, use: "primary", size: "medium", children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }), _jsx(Button, { onClick: onCancel, size: "medium", children: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C" })] })] }));
};
